export interface AcademySetupFaqItem {
  titleKey: string;
  url: string;
}

export const academySetupFaqItems: AcademySetupFaqItem[] = [
  {
    titleKey: "Booking Session (Coach)",
    url: "https://help.coachnow.io/en/articles/10288168-booking-session-coach",
  },
  {
    titleKey: "Advanced Booking Options and Availability Settings",
    url: "https://help.coachnow.io/en/articles/12052970-advanced-booking-options-and-availability-settings",
  },
  {
    titleKey: "Billing - Through Stripe Connect",
    url: "https://help.coachnow.io/en/articles/12270037-billing-through-stripe-connect",
  },
  {
    titleKey: "Blocking Unavailable Time Slots",
    url: "https://help.coachnow.io/en/articles/10288174-blocking-unavailable-time-slots",
  },
  {
    titleKey: "Connect Multiple CoachNow Academy Accounts to one Stripe Account",
    url: "https://help.coachnow.io/en/articles/12610547-connect-multiple-coachnow-academy-accounts-to-one-stripe-account",
  },
];

export const BOOK_A_DEMO_URL = "https://coachnow.io/demo?utm_source=academysetup";
